import { useContext } from 'react';
import { ChatContext } from '../context';

const FeatureFlag = {
  AI_FRIEND: 'AIFriend',
};

const usePostHog = () => {
  const { posthog } = useContext(ChatContext);
  const isFeatureEnabled = (featureFlag) => posthog.isFeatureEnabled(featureFlag);

  const isAIFriendEnabled = () => isFeatureEnabled(FeatureFlag.AI_FRIEND);

  return {
    isFeatureEnabled,
    isAIFriendEnabled,
  };
};

export {
  usePostHog,
};
